import React from 'react';
import Lottie from 'lottie-react';
import cx from 'classnames';
import animationData from '../../../../animations/lottie/loader-screen-loader.json.js';
import styles from './index.module.scss.js';

const ScreenLoader = ({
  isFullPage = true,
  isFullHeight = true
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx({
      [styles["box-full"]]: isFullPage,
      [styles["box-component"]]: !isFullPage,
      [styles["parent-container-height"]]: !isFullHeight
    })
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.animation }, /* @__PURE__ */ React.createElement(Lottie, { animationData, autoPlay: true, loop: true }))
);
ScreenLoader.displayName = "ScreenLoader";

export { ScreenLoader };
//# sourceMappingURL=index.js.map
